import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    flags : [],
}

export const loadingSlice = createSlice({
    name: "loading",
    initialState,
    reducers: {
        setLoadingFlag: (state, action) => {
            const key = Object.keys(action.payload)[0];
            const value = action.payload[key];

            // console.log(key, value)

            var v = value === true ? true : 
                value === false ? false : -1;

            var found = false
            state.flags.forEach(e => {
                if(e.tag == key) {
                    found = true
                    if(v == -1) {
                        e.value = !e.value
                    } else {
                        e.value = v
                    }
                }
            })

            if(!found) {
                state.flags.push({
                    tag : key,
                    value : value
                })
            }
        }
    }
});

export const {
    setLoadingFlag,
} = loadingSlice.actions;

export default loadingSlice.reducer;